import { useCallback } from 'react'

import RefreshIcon from '@/assets/icons/icon-replay.svg'
import { Button } from '@/components/ui/button.tsx'
import { SearchInput } from '@/components/ui/search-input.tsx'
import { debounce } from '@/utils/helpers'

interface SharedFollowersHeaderButtonsProps {
  onRefreshPress: () => void
  setFilter: (filter: string) => void
}

export const SharedFollowersHeaderButtons: React.FC<
  SharedFollowersHeaderButtonsProps
> = ({ onRefreshPress, setFilter }) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleInputChange = useCallback(debounce(setFilter, 500), [setFilter])

  return (
    <div className="flex items-center gap-2">
      <SearchInput
        placeholder="Search"
        onInputChange={handleInputChange}
      />
      <Button
        className="gap-1"
        onClick={onRefreshPress}
      >
        <RefreshIcon />
        <span className="inline">Refresh</span>
      </Button>
    </div>
  )
}
